"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
window.site = window.site || {};

/**
 * Utilities for Google Analytics.
 * @class Track
 * @static
 */
site.ContentWithSlider = function ContentWithSlider() {
  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function init() {
    // Abort if already initialized
    if (inited) {
      return false;
    }
    inited = true;
    var $sliders = document.querySelectorAll('.content-with-slider .column-side.slider');
    if ($sliders.length) {
      $sliders.forEach(function ($slider) {
        var flkty = new Flickity($slider, {
          // options
          cellAlign: 'left',
          contain: true,
          prevNextButtons: false
        });
        manageFocusableElements(flkty);
        flkty.on('change', function () {
          manageFocusableElements(flkty);
        });
      });
    }
    var $printTrigger = document.querySelector('.blog-print');
    if ($printTrigger) {
      $printTrigger === null || $printTrigger === void 0 || $printTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        window.print();
      });
    }
    var $blogSliders = document.querySelectorAll('.blog-slider');
    if ($blogSliders.length) {
      $blogSliders.forEach(function ($blogSlider) {
        var flkty = new Flickity($blogSlider, {
          // options
          cellAlign: 'left',
          contain: true,
          prevNextButtons: true
        });
        manageFocusableElements(flkty);
        flkty.on('change', function () {
          manageFocusableElements(flkty);
        });
      });
    }
    if (window.innerWidth < 768) {
      var ItcCustomSelect = /*#__PURE__*/function () {
        function ItcCustomSelect(target, params) {
          _classCallCheck(this, ItcCustomSelect);
          this._el = typeof target === "string" ? document.querySelector(target) : target;
          this._params = params || {};
          this._onClickFn = this._onClick.bind(this);
          if (this._params.options) {
            this._el.innerHTML = this.constructor.template(this._params);
            this._el.classList.add(this.constructor.EL);
          }
          this._elToggle = this._el.querySelector(this.constructor.DATA_TOGGLE);
          this._el.addEventListener("click", this._onClickFn);
        }
        return _createClass(ItcCustomSelect, [{
          key: "_onClick",
          value: function _onClick(e) {
            var target = e.target;
            var type = target.closest(this.constructor.DATA).dataset.select;
            if (type === "toggle") {
              this.toggle();
            } else if (type === "option") {
              this._changeValue(target);
            }
          }
        }, {
          key: "_updateOption",
          value: function _updateOption(el) {
            var elOption = el.closest(".".concat(this.constructor.EL_OPTION));
            var elOptionSel = this._el.querySelector(".".concat(this.constructor.EL_OPTION_SELECTED));
            if (elOptionSel) {
              elOptionSel.classList.remove(this.constructor.EL_OPTION_SELECTED);
            }
            elOption.classList.add(this.constructor.EL_OPTION_SELECTED);
            this._elToggle.textContent = elOption.textContent;
            this._elToggle.value = elOption.dataset.value;
            this._elToggle.dataset.index = elOption.dataset.index;
            this._el.dispatchEvent(new CustomEvent("itc.select.change"));
            this._params.onSelected ? this._params.onSelected(this, elOption) : null;
            return elOption.dataset.value;
          }
        }, {
          key: "_reset",
          value: function _reset() {
            var selected = this._el.querySelector(".".concat(this.constructor.EL_OPTION_SELECTED));
            if (selected) {
              selected.classList.remove(this.constructor.EL_OPTION_SELECTED);
            }
            this._elToggle.textContent = "Choisir une catégorie";
            this._elToggle.value = "";
            this._elToggle.dataset.index = "-1";
            this._el.dispatchEvent(new CustomEvent("itc.select.change"));
            this._params.onSelected ? this._params.onSelected(this, null) : null;
            return "";
          }
        }, {
          key: "_changeValue",
          value: function _changeValue(el) {
            if (el.classList.contains(this.constructor.EL_OPTION_SELECTED)) {
              return;
            }
            this._updateOption(el);
            this.hide();
          }
        }, {
          key: "show",
          value: function show() {
            var _this = this;
            document.querySelectorAll(this.constructor.EL_SHOW).forEach(function (el) {
              el.classList.remove(_this.constructor.EL_SHOW);
            });
            this._el.classList.add("".concat(this.constructor.EL_SHOW));
          }
        }, {
          key: "hide",
          value: function hide() {
            this._el.classList.remove(this.constructor.EL_SHOW);
          }
        }, {
          key: "toggle",
          value: function toggle() {
            this._el.classList.contains(this.constructor.EL_SHOW) ? this.hide() : this.show();
          }
        }, {
          key: "dispose",
          value: function dispose() {
            this._el.removeEventListener("click", this._onClickFn);
          }
        }, {
          key: "value",
          get: function get() {
            return this._elToggle.value;
          },
          set: function set(value) {
            var _this2 = this;
            var isExists = false;
            this._el.querySelectorAll(".select__option").forEach(function (option) {
              if (option.dataset.value === value) {
                isExists = true;
                _this2._updateOption(option);
              }
            });
            if (!isExists) {
              this._reset();
            }
          }
        }, {
          key: "selectedIndex",
          get: function get() {
            return this._elToggle.dataset.index;
          },
          set: function set(index) {
            var option = this._el.querySelector(".select__option[data-index=\"".concat(index, "\"]"));
            if (option) {
              this._updateOption(option);
            }
            this._reset();
          }
        }], [{
          key: "template",
          value: function template(params) {
            var _this3 = this;
            var name = params.name,
              options = params.options,
              targetValue = params.targetValue;
            var items = [];
            var selectedIndex = -1;
            var selectedValue = "";
            var selectedContent = "Выберите из списка";
            options.forEach(function (option, index) {
              var selectedClass = "";
              if (option[0] === targetValue) {
                selectedClass = " ".concat(_this3.EL_OPTION_SELECTED);
                selectedIndex = index;
                selectedValue = option[0];
                selectedContent = option[1];
              }
              items.push("<li class=\"itc-select__option".concat(selectedClass, "\" data-select=\"option\"\n              data-value=\"").concat(option[0], "\" data-index=\"").concat(index, "\">").concat(option[1], "</li>"));
            });
            return "<button type=\"button\" class=\"itc-select__toggle\" name=\"".concat(name, "\"\n            value=\"").concat(selectedValue, "\" data-select=\"toggle\" data-index=\"").concat(selectedIndex, "\">\n            ").concat(selectedContent, "</button><div class=\"itc-select__dropdown\">\n            <ul class=\"itc-select__options\">").concat(items.join(""), "</ul></div>");
          }
        }, {
          key: "hideOpenSelect",
          value: function hideOpenSelect() {
            var _this4 = this;
            document.addEventListener("click", function (e) {
              if (!e.target.closest(".".concat(_this4.EL))) {
                var elsActive = document.querySelectorAll(".".concat(_this4.EL_SHOW));
                elsActive.forEach(function (el) {
                  el.classList.remove(_this4.EL_SHOW);
                });
              }
            });
          }
        }, {
          key: "create",
          value: function create(target, params) {
            this._el = typeof target === "string" ? document.querySelector(target) : target;
            if (this._el) {
              return new this(target, params);
            }
            return null;
          }
        }]);
      }();
      _defineProperty(ItcCustomSelect, "EL", "itc-select");
      _defineProperty(ItcCustomSelect, "EL_SHOW", "itc-select_show");
      _defineProperty(ItcCustomSelect, "EL_OPTION", "itc-select__option");
      _defineProperty(ItcCustomSelect, "EL_OPTION_SELECTED", "itc-select__option_selected");
      _defineProperty(ItcCustomSelect, "DATA", "[data-select]");
      _defineProperty(ItcCustomSelect, "DATA_TOGGLE", '[data-select="toggle"]');
      ItcCustomSelect.hideOpenSelect();
      var select = document.querySelector("#select-1");
      if (select) {
        var select1 = new ItcCustomSelect("#select-1");
      }
    }
    return true;
  };
  var manageFocusableElements = function manageFocusableElements(carousel) {
    var slides = carousel.cells;
    slides.forEach(function (slide, index) {
      var focusableElements = slide.element.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (index === carousel.selectedIndex) {
        focusableElements.forEach(function (el) {
          return el.removeAttribute('tabindex');
        });
      } else {
        focusableElements.forEach(function (el) {
          return el.setAttribute('tabindex', '-1');
        });
      }
    });
  };

  // Expose public methods & properties
  return {
    init: init
  };
}();